<template>
	<div class="applications">
		<p class="head-regular">
			{{ applicationsText }}
		</p>

		<ul class="applications__list">
			<li v-for="(sa, i) in summaryApplications" :key="i">
				<button class="link">
					<NuxtLink :to="{ path: createApplicationLink(sa) }" replace>
						<span>{{ mountFitApplications(sa) }}</span>
					</NuxtLink>
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		applicationsQuantity: {
			type: Number,
			default: 0,
		},
		summaryApplications: {
			type: Array,
			default: [],
		},
	},
	methods: {
		createApplicationLink(application) {
			let arrayIntervaloAnos = []
			for (var i = application.a1; i <= application.a2; i++) {
				arrayIntervaloAnos.push(i)
			}

			const veiculo = application.moto.toLowerCase().replace("!", "")

			let filter = `?veiculo=${veiculo}`
			if (arrayIntervaloAnos.length > 0) {
				for (const ano of arrayIntervaloAnos) {
					filter = filter + `&ano=${ano}`
				}
			}

			const url = `/lista/${filter}`
			return url
		},
		mountFitApplications(application) {
			if (application.mod === "''") {
				return application.moto + " " + this.applicationYear(application)
			} else {
				return application.moto + " " + application.mod + " " + this.applicationYear(application)
			}
		},
		applicationYear(application) {
			if (application.a1 === application.a2) {
				return application.a1
			} else {
				return application.a1 + " - " + application.a2
			}
		},
	},
	computed: {
		applicationsText() {
			if (this.applicationsQuantity === 0) {
				return "Este produto não tem aplicações cadastradas."
			} else if (this.applicationsQuantity === 1) {
				return `Este produto tem ${this.applicationsQuantity} aplicação. Confira algumas:`
			} else {
				return `Este produto tem ${this.applicationsQuantity} aplicações. Confira algumas:`
			}
		},
		brandPrefix() {
			if (process.env.ENV_NAME) {
				return process.env.ENV_NAME
			}
			return
		},
	},
}
</script>

<style scoped lang="scss">
.applications {
	max-height: 240px;
	overflow-y: scroll;
	p {
		font-size: 16px;
		line-height: 19px;
		color: #3c484d;
		padding: 0;
		margin-bottom: 16px;
	}
	&__list {
		display: grid;
		row-gap: 16px;
		padding: 0px 0px 0px 8px;
		li {
			font-size: 16px;
			line-height: 19px;
			&::before {
				content: "—";
				transform: translateY(-0.05em);
				font-weight: bold;
				margin-right: 8px;
			}
		}
	}
}
</style>
